import { resourceService } from "@libs/axios";
import {
  fetchModuleList, fetchBankSupportList,
  fetchSchoolModuleList, fetchUserDetail, fetchNewWardList
} from "@store/actions/comonActions";
import {
  setBankSupportList,
  setLoadingBankSupport,
  setModuleList,
  setLoadingModule,
  setSchoolModuleList,
  setLoadingSchoolModule,
  setUserDetail,
  setLoadingUserDetail,
  setNewWardList,
  setLoadingNewWard
} from "@store/reducers/commonReducer";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResponseType } from "@store/index";
const API_URL = process.env.REACT_APP_API_URL;

function* fetchModuleListSaga(action: any) {
  try {
    yield put(setLoadingModule(true));
    const { filters } = action.payload;

    const response: ResponseType = yield call(resourceService.get,
      API_URL + '/api/modules/', {
      params: {
        status: filters.status,
        name: filters.name,
        page: filters.page,
        page_size: filters.page_size,
        type: filters.module_type,
        ...(filters.partner !== null && filters.partner !== undefined && filters.partner !== '' ? { partner: filters.partner } : {}),
      }
    }
    )

    if (response.status === 200) {
      yield put(setModuleList(response.data));
    }
  }
  catch (error) {
    yield put(setModuleList([]));
  }
  finally {
    yield put(setLoadingModule(false));
  }
}

function* fetchBankSupportListSaga() {
  try {
    yield put(setLoadingBankSupport(true))
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/bank_supports`)
    if (response.status === 200) {
      yield put(setBankSupportList(response.data?.results));
    }
  }
  catch (error) {
    console.log(error)
  }
  finally {
    yield put(setLoadingBankSupport(false))
  }
}

function* fetchSchoolModuleListSaga(action: any) {
  try {
    yield put(setLoadingSchoolModule(true));
    const { filters } = action.payload;
    const schoolId = filters.school;
    if (schoolId === undefined) {
      yield put(setSchoolModuleList([]));
    } else {
      const response: ResponseType = yield call(resourceService.get, API_URL + `/api/schools/${schoolId}/modules/`,
        {
          params: {
          }
        }
      )

      if (response.status === 200) {
        yield put(setSchoolModuleList(response.data));
      }
    }
  }
  catch (error) {
    yield put(setSchoolModuleList([]));
  }
  finally {
    yield put(setLoadingSchoolModule(false));
  }
}
function* fetchUserDetailSaga(action: ReturnType<typeof fetchUserDetail>) {
  try {
    yield put(setLoadingUserDetail(true));
    const userId = action.payload.id;
    const response: ResponseType = yield call(resourceService.get, API_URL + `/api/users/${userId}/`);
    if (response.status === 200) {
      yield put(setUserDetail(response.data));
    }
  } catch (error) {
    console.error("Fetch user detail error:", error);
  } finally {
    yield put(setLoadingUserDetail(false));
  }

}

function* fetchNewWardListSaga(action: ReturnType<typeof fetchNewWardList>) {
  try {
    yield put(setLoadingNewWard(true));
    const { provinceId } = action.payload;
    if (provinceId === undefined || provinceId === null) {
      yield put(setNewWardList([]));
    } else {
      const response: ResponseType = yield call(
        resourceService.get,
        API_URL + `/api/address2/wards-by-province/?province_code=${provinceId}&page_size=1000`,
      );
      if (response.status === 200) {
          yield put(setNewWardList(response.data?.data));
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    yield put(setLoadingNewWard(false));
  }
}
export default function* commonSaga() {
  yield takeLatest(fetchModuleList, fetchModuleListSaga)
  yield takeLatest(fetchBankSupportList, fetchBankSupportListSaga)
  yield takeLatest(fetchSchoolModuleList, fetchSchoolModuleListSaga)
  yield takeLatest(fetchNewWardList, fetchNewWardListSaga)
  yield takeLatest(fetchUserDetail, fetchUserDetailSaga)
}
